import React, { useState, useEffect } from 'react';
import NavbarStandard from '../landing/NavbarStandard';
import FooterStandard from '../landing/FooterStandard';
import {
  FiArrowRight,
  FiLayers,
  FiDatabase,
  FiRefreshCw,
  FiCheckCircle,
  FiTerminal,
  FiCpu,
  FiTrendingUp,
  FiCopy,
  FiAward
} from 'react-icons/fi';

// Define the presets
const PRESETS = {
  grocery: {
    id: 'grocery',
    name: 'Food & Beverage Wholesaler',
    raw: `SKU: 84011-B
Desc: REDS HOT SAUCE 12/12OZ CS
Cost: 24.50
Brand: Red's
Qty: 140
UPC: 012345678912
Origin: Louisiana, USA`,
    enriched: {
      title:
        "Red's Authentic Louisiana Hot Sauce (12-Pack, 12 oz Bottles) – Wholesale Case",
      category:
        'Food & Beverage > Pantry Staples > Condiments & Sauces > Hot Sauces',
      categoryCode: 'Shopify Category ID: #6143',
      retailPrice: 34.99,
      cost: 24.5,
      margin: '30%',
      profit: 10.49,
      description:
        "Elevate your culinary offerings with Red's Authentic Louisiana Hot Sauce. Crafted in the heart of Louisiana, this premium hot sauce features perfectly aged cayenne peppers, distilled vinegar, and a proprietary blend of savory spices. It delivers the signature tangy heat that Southern hot sauce is famous for, without overpowering the natural flavors of your dishes. This commercial-grade wholesale case contains 12 convenient 12-ounce glass bottles, perfect for restaurant tabletop service, retail grocery shelves, or C-store condiment stations.",
      features: [
        {
          title: 'Classic Tangy Heat',
          desc: 'Balanced heat profile with a smooth vinegar tang and rich pepper aroma.'
        },
        {
          title: 'Aged Cayenne Peppers',
          desc: 'Sourced from local Southern farms and aged to perfection for consistent heat.'
        },
        {
          title: 'Wholesale Bulk Pack',
          desc: 'Contains 12 individually barcoded 12-ounce glass bottles, ideal for retail or hospitality.'
        },
        {
          title: 'All-Natural & Gluten-Free',
          desc: 'No artificial preservatives, thickeners, or GMO ingredients.'
        }
      ],
      attributes: {
        SKU: '84011-B',
        'Manufacturer/Brand': "Red's",
        'Case Pack Size': '12 Bottles x 12 oz (8.6 lbs case weight)',
        'Bottle Dimensions': '2.2" W x 7.8" H',
        Ingredients:
          'Aged Cayenne Peppers, Distilled Vinegar, Water, Salt, Garlic Powder',
        'Inventory Status': 'In Stock (140 cases available)'
      },
      tags: [
        'hot-sauce',
        'bulk-condiments',
        'louisiana-heat',
        'wholesale-grocery',
        'pantry-staples'
      ],
      json: {
        product: {
          title:
            "Red's Authentic Louisiana Hot Sauce (12-Pack, 12 oz Bottles) – Wholesale Case",
          body_html:
            "<p>Elevate your culinary offerings with Red's Authentic Louisiana Hot Sauce...</p>",
          vendor: "Red's",
          product_type: 'Condiments & Sauces',
          status: 'draft',
          tags: [
            'hot-sauce',
            'bulk-condiments',
            'louisiana-heat',
            'wholesale-grocery'
          ],
          variants: [
            {
              sku: '84011-B',
              price: '34.99',
              compare_at_price: '42.00',
              cost_per_item: '24.50',
              inventory_quantity: 140,
              barcode: '012345678912',
              weight: 8.6,
              weight_unit: 'lb'
            }
          ],
          metafields: [
            {
              namespace: 'custom',
              key: 'case_pack',
              value: '12x12oz',
              type: 'single_line_text_field'
            },
            {
              namespace: 'custom',
              key: 'spice_level',
              value: 'Medium (tangy)',
              type: 'single_line_text_field'
            }
          ]
        }
      },
      copy: {
        social:
          "🔥 Heat up your shelves! Now stocking Red's Authentic Louisiana Hot Sauce in wholesale cases. Aged cayenne peppers, zero artificial fillers, and the signature Southern kick your customers love. Tabletop-ready 12 oz bottles, 12 per case. Order yours today! #HotSauceWholesale #LouisianaHeat #B2BGrocery",
        email:
          "Subject: Margin Alert: Spice Up Your Sauce Aisles with Red's 12-Pack Case\n\nDear Retail Partner,\n\nWe're excited to introduce Red's Authentic Louisiana Hot Sauce in commercial wholesale cases. Sourced from local Southern farms and aged to perfection, this classic tangy sauce delivers incredible margins (30%+) and high shelf velocity. Each case features 12 individually barcoded 12 oz bottles, perfect for tabletop restaurant service or grocery display. Order on our wholesale portal today to receive immediate shipping.",
        wholesale:
          "Red's Louisiana Hot Sauce (12x12oz). Commercial-grade bulk case of tangy, medium-heat hot sauce. Made from premium aged cayenne peppers. Gluten-free, table-ready, and optimized for high-volume grocery retail."
      }
    }
  },
  marine: {
    id: 'marine',
    name: 'Marine Specialty Distributor',
    raw: `SKU: MAR-TKL-102
Desc: STAINLESS BOW SHACKLE 3/8IN 5PK
Cost: 12.00
Brand: SeaLink
Qty: 85
Material: 316 Stainless Steel
Load Rating: 2,200 lbs`,
    enriched: {
      title:
        'SeaLink Marine-Grade 316 Stainless Steel Bow Shackles (3/8" Pin, 5-Pack)',
      category:
        'Vehicles & Parts > Watercraft Parts & Accessories > Boat Parts > Deck Hardware & Rigging',
      categoryCode: 'Shopify Category ID: #4852',
      retailPrice: 24.99,
      cost: 12.0,
      margin: '52%',
      profit: 12.99,
      description:
        'Engineered for harsh marine environments, the SeaLink Marine-Grade Bow Shackle is forged from premium 316 stainless steel, offering maximum corrosion resistance and durability. The 3/8-inch screw pin ensures a secure lock for anchor chains, docking lines, rigging wire, and towing lines. Designed with a wide bow shape, this shackle accommodates larger lines and multiple connections without binding. This wholesale package includes five individually bagged shackles, making it an excellent product for boat dealers, marine chandleries, or retail pegboards.',
      features: [
        {
          title: 'Premium 316 Stainless Steel',
          desc: 'Superior rust and pitting resistance compared to standard steel, even in harsh saltwater.'
        },
        {
          title: 'Heavy-Duty Load Rating',
          desc: 'Working Load Limit (WLL) of 2,200 lbs (1.1 Tons) with a 4:1 safety factor.'
        },
        {
          title: 'Wide Bow Architecture',
          desc: 'Allows for easy attachment of thick lines, thimbles, and heavy anchor chain links.'
        },
        {
          title: 'Wholesale Multi-Pack',
          desc: 'Packaged as a convenient set of 5 shackles, individually labeled with barcoding.'
        }
      ],
      attributes: {
        SKU: 'MAR-TKL-102',
        'Manufacturer/Brand': 'SeaLink',
        Material: '316 Marine-Grade Stainless Steel',
        'Pin Diameter': '3/8" (9.5mm)',
        'Working Load Limit': '2,200 lbs (WLL)',
        'Quantity/Pack': '5 Shackles per retail box',
        'Inventory Status': 'In Stock (85 packs available)'
      },
      tags: [
        'marine-hardware',
        'stainless-shackle',
        'boat-rigging',
        '316-stainless',
        'anchor-shackle'
      ],
      json: {
        product: {
          title:
            'SeaLink Marine-Grade 316 Stainless Steel Bow Shackles (3/8" Pin, 5-Pack)',
          body_html: '<p>Engineered for harsh marine environments...</p>',
          vendor: 'SeaLink',
          product_type: 'Deck Hardware',
          status: 'draft',
          tags: [
            'marine-hardware',
            'stainless-shackle',
            'boat-rigging',
            '316-stainless'
          ],
          variants: [
            {
              sku: 'MAR-TKL-102',
              price: '24.99',
              cost_per_item: '12.00',
              inventory_quantity: 85,
              weight: 1.2,
              weight_unit: 'lb'
            }
          ],
          metafields: [
            {
              namespace: 'custom',
              key: 'material_grade',
              value: '316 Stainless Steel',
              type: 'single_line_text_field'
            },
            {
              namespace: 'custom',
              key: 'working_load_limit',
              value: '2200 lbs',
              type: 'single_line_text_field'
            }
          ]
        }
      },
      copy: {
        social:
          '⚓️ Rig with confidence! The SeaLink Marine 3/8" Bow Shackle 5-Pack is back in stock. Forged from premium 316 Stainless Steel for extreme saltwater defense. Rated for 2,200 lbs. Essential tackle for every commercial and recreational vessel. Packaged for retail pegboards. Shop wholesale now! #MarineRigging #BoatingHardware #316Stainless',
        email:
          'Subject: High-Margin Marine Hardware: 316 Stainless Bow Shackles In Stock\n\nHi Captain,\n\nWe\'ve just replenished inventory on our high-demand SeaLink 3/8" Stainless Bow Shackles. Offering an incredible 52% margin for marine dealers, these forged 316-grade steel hardware pieces are impervious to saltwater pitting. Each contractor box contains 5 individually barcoded shackles. High-durability deck hardware is a steady seller in this region — log into your portal and claim your allocation before the weekend rush.',
        wholesale:
          'SeaLink Bow Shackles (5-pack). Forged 316 marine-grade stainless steel with 3/8" screw pin. 2,200 lbs WLL (Working Load Limit). Ideal for boating rigging, anchoring, and marine dock hardware. Heavy-duty construction.'
      }
    }
  },
  coffee: {
    id: 'coffee',
    name: 'Specialty Coffee Wholesaler',
    raw: `SKU: COF-SUM-12BG
Desc: SUMATRA MANDHELING GRD 12/12OZ
Cost: 82.50
Brand: IslandRoast
Qty: 30
Roast: Dark
Grind: Drip Grind (Medium)`,
    enriched: {
      title:
        'IslandRoast Sumatra Mandheling Dark Roast Ground Coffee (12-Pack, 12 oz Bags)',
      category: 'Food & Beverage > Beverages > Coffee > Ground Coffee',
      categoryCode: 'Shopify Category ID: #3263',
      retailPrice: 124.99,
      cost: 82.5,
      margin: '34%',
      profit: 42.49,
      description:
        'Experience the rich heritage of Indonesian coffee with IslandRoast Sumatra Mandheling Ground Coffee. Grown in the volcanic Highlands of Northern Sumatra, these single-origin Arabica beans undergo the traditional wet-hulling process (Giling Basah), resulting in an exceptionally smooth, full-bodied cup with low acidity. Roasted to a deep dark profile, it reveals complex notes of sweet cedar, dark chocolate, and spicy earthiness. This case contains twelve 12-ounce foil bags equipped with one-way degassing valves to lock in freshness, perfect for office pantries, boutique coffee shops, or retail grocery shelves.',
      features: [
        {
          title: 'Single-Origin Arabica',
          desc: '100% Sumatra Mandheling Arabica beans, renowned worldwide for their rich, heavy body.'
        },
        {
          title: 'Complex Flavor Profile',
          desc: 'Distinctive tasting notes of dark cocoa, warm cedar wood, and subtle herbal spices.'
        },
        {
          title: 'Dark Roast Excellence',
          desc: 'Slowly roasted to draw out essential oils, delivering a robust, low-acidity cup.'
        },
        {
          title: 'Freshness Sealed Case',
          desc: '12 individually valved 12-ounce bags, drip ground for immediate brewing convenience.'
        }
      ],
      attributes: {
        SKU: 'COF-SUM-12BG',
        'Manufacturer/Brand': 'IslandRoast',
        'Roast Level': 'Dark',
        'Grind Type': 'Drip Grind (Medium)',
        'Package Weight': '12 oz per bag (9.0 lbs case weight)',
        'Case Pack Size': '12 Bags per case',
        'Inventory Status': 'In Stock (30 cases available)'
      },
      tags: [
        'sumatra-mandheling',
        'dark-roast-coffee',
        'wholesale-coffee',
        'single-origin-ground',
        'island-roast'
      ],
      json: {
        product: {
          title:
            'IslandRoast Sumatra Mandheling Dark Roast Ground Coffee (12-Pack, 12 oz Bags)',
          body_html:
            '<p>Experience the rich heritage of Indonesian coffee...</p>',
          vendor: 'IslandRoast',
          product_type: 'Ground Coffee',
          status: 'draft',
          tags: ['sumatra-mandheling', 'dark-roast-coffee', 'wholesale-coffee'],
          variants: [
            {
              sku: 'COF-SUM-12BG',
              price: '124.99',
              cost_per_item: '82.50',
              inventory_quantity: 30,
              weight: 9.0,
              weight_unit: 'lb'
            }
          ]
        }
      },
      copy: {
        social:
          "☕️ Single-origin intensity, dark roasted perfection. IslandRoast's Sumatra Mandheling ground coffee is now available in wholesale cases of 12! Hand-harvested in the volcanic soil of Northern Sumatra and wet-hulled for ultra-low acidity and a velvety body. Perfect for high-end grocery, cafes, and premium offices. Order a case of 12 today! #SumatraMandheling #DarkRoastCoffee #GroundCoffeeWholesale",
        email:
          "Subject: Premium Coffee Allocation: Single-Origin Sumatra Mandheling Ground (12-Bags Case)\n\nHello Coffee Retailer,\n\nTap into the fast-growing specialty single-origin coffee market with IslandRoast's Sumatra Mandheling Ground Coffee cases. Featuring a healthy 34% margin, these volcanic highlands dark roast bags provide a deep flavor profile of cocoa and cedar with near-zero acidity. Ground specifically for drip brewing, each bag has a one-way freshness valve. Place an order today and elevate your coffee selection.",
        wholesale:
          'IslandRoast Sumatra Mandheling ground coffee case. 12 single-origin 12 oz bags. Slow-roasted dark roast, medium drip grind, low acidity with chocolate and earthy spice notes. High-density commercial packaging.'
      }
    }
  },
  fastener: {
    id: 'fastener',
    name: 'Industrial Fastener Distributor',
    raw: `SKU: BOLT-HX-516
Desc: GR8 HEX BOLT 5/16-18X1.5 ZINC 100BX
Cost: 16.20
Brand: ApexFasten
Qty: 210
Thread: 5/16"-18 UNC
Length: 1-1/2 inches
Grade: Grade 8 Carbon Steel`,
    enriched: {
      title:
        'ApexFasten Grade 8 Zinc-Plated Carbon Steel Hex Bolts (5/16"-18 x 1-1/2", 100-Pack Box)',
      category: 'Hardware > Fasteners > Screws & Bolts > Bolts',
      categoryCode: 'Shopify Category ID: #2104',
      retailPrice: 28.5,
      cost: 16.2,
      margin: '43%',
      profit: 12.3,
      description:
        'Built for demanding structural, automotive, and industrial applications, the ApexFasten Grade 8 Hex Head Bolt offers maximum tensile strength and durability. Manufactured from high-strength carbon steel, heat-treated and tempered, these bolts are yellow zinc-plated to resist rust and corrosion in tough indoor and outdoor settings. Featuring a 5/16"-18 UNC coarse thread and a 1.5-inch length, they meet SAE J429 standards with a minimum tensile strength of 150,000 PSI. Supplied in a heavy-duty contractor-pack box of 100 pieces with clear, scannable SKU labels.',
      features: [
        {
          title: 'Grade 8 High-Tensile Steel',
          desc: 'Tempered carbon steel providing 150,000 PSI tensile strength for critical structural fastening.'
        },
        {
          title: 'Zinc-Plated Yellow Coating',
          desc: 'Yellow zinc dichromate finish provides outstanding protection against pitting and rust.'
        },
        {
          title: 'SAE J429 Standards Compliant',
          desc: 'Meets rigorous mechanical and chemical industrial standards for safety and loading.'
        },
        {
          title: 'Bulk Contractor Box',
          desc: 'Packaged in a robust box of 100 bolts, designed for dusty warehouse environments and retail pegboards.'
        }
      ],
      attributes: {
        SKU: 'BOLT-HX-516',
        'Manufacturer/Brand': 'ApexFasten',
        'Material/Grade': 'SAE J429 Grade 8 Medium Carbon Alloy Steel',
        Finish: 'Yellow Zinc Dichromate Plating',
        'Thread Size': '5/16"-18 (Coarse UNC)',
        'Bolt Length': '1-1/2 inches (1.50")',
        'Quantity/Pack': '100 Bolts per box',
        'Inventory Status': 'In Stock (210 boxes available)'
      },
      tags: [
        'grade-8-bolts',
        'hex-head-bolt',
        'industrial-fasteners',
        'zinc-plated-steel',
        'contractor-pack'
      ],
      json: {
        product: {
          title:
            'ApexFasten Grade 8 Zinc-Plated Carbon Steel Hex Bolts (5/16"-18 x 1-1/2", 100-Pack Box)',
          body_html:
            '<p>Built for demanding structural, automotive, and industrial applications...</p>',
          vendor: 'ApexFasten',
          product_type: 'Hex Bolts',
          status: 'draft',
          tags: [
            'grade-8-bolts',
            'hex-head-bolt',
            'industrial-fasteners',
            'zinc-plated-steel'
          ],
          variants: [
            {
              sku: 'BOLT-HX-516',
              price: '28.50',
              cost_per_item: '16.20',
              inventory_quantity: 210,
              weight: 3.8,
              weight_unit: 'lb'
            }
          ]
        }
      },
      copy: {
        social:
          '🔩 Zero failures, total strength. Stock up on ApexFasten Grade 8 Hex Head Bolts (5/16"-18 x 1-1/2"). Engineered from high-strength tempered carbon alloy steel for 150K PSI tensile strength, coated in corrosion-fighting yellow zinc. Packaged in tough 100-count contractor boxes. In stock and shipping wholesale! #IndustrialFasteners #Grade8Bolts #ContractorSupply',
        email:
          'Subject: Supply Chain Update: Grade 8 Carbon Steel Hex Bolts Yellow Zinc In Stock\n\nDear Buying Desk,\n\nWe\'ve received a large inventory allocation of ApexFasten SAE Grade 8 Hex Head Bolts in the popular 5/16"-18 x 1.5" configuration. Formulated to resist sheer stress with a 150,000 PSI load limit, these bolts are coated in yellow zinc chromate for outdoor marine and mechanical use. Sold in robust 100-count cardboard storage cases. High margin (43%) and zero returns. Secure your industrial fastener orders today.',
        wholesale:
          'ApexFasten SAE Grade 8 Hex Head Bolt. Yellow zinc-plated carbon alloy steel. 5/16"-18 UNC coarse threads, 1-1/2 inch length. Meets SAE J429 standards. Packaged in commercial contractor boxes of 100.'
      }
    }
  }
};

const CatalogEnricherDemo = () => {
  const [selectedPreset, setSelectedPreset] = useState('grocery');
  const [rawText, setRawText] = useState('');
  const [targetChannel, setTargetChannel] = useState('shopify');
  const [tone, setTone] = useState('seo');

  const [enriching, setEnriching] = useState(false);
  const [enrichStep, setEnrichStep] = useState(0);
  const [enrichedData, setEnrichedData] = useState(null);
  const [activeTab, setActiveTab] = useState('preview');

  // Initialize with grocery preset
  useEffect(() => {
    setRawText(PRESETS.grocery.raw);
    setEnrichedData(PRESETS.grocery.enriched);
  }, []);

  // Set preset handler
  const handlePresetSelect = presetKey => {
    setSelectedPreset(presetKey);
    setRawText(PRESETS[presetKey].raw);
    setEnrichedData(PRESETS[presetKey].enriched);
    setActiveTab('preview');
  };

  // Run the enrichment simulator
  const handleEnrich = e => {
    e.preventDefault();
    setEnriching(true);
    setEnrichStep(1);
    setActiveTab('preview');

    // Multi-step progress bar simulation (total ~4.5 seconds of high-fidelity feel)
    const timers = [
      setTimeout(() => setEnrichStep(2), 900),
      setTimeout(() => setEnrichStep(3), 1800),
      setTimeout(() => setEnrichStep(4), 2700),
      setTimeout(() => setEnrichStep(5), 3500),
      setTimeout(() => {
        // If they modified the raw text, build a custom response based on their input
        // otherwise load the static matching preset data
        const currentPreset = Object.values(PRESETS).find(
          p => p.raw.trim() === rawText.trim()
        );

        if (currentPreset) {
          setEnrichedData(currentPreset.enriched);
        } else {
          // Dynamic text generation based on custom typing
          const customEnriched = generateCustomEnriched(
            rawText,
            targetChannel,
            tone
          );
          setEnrichedData(customEnriched);
        }

        setEnriching(false);
        setEnrichStep(0);
      }, 4200)
    ];

    return () => timers.forEach(clearTimeout);
  };

  // Simple heuristic generator for custom typed rows so the demo is truly functional
  const generateCustomEnriched = (input, channel, selectedTone) => {
    // Basic text token parsing
    const lines = input.split('\n');
    let sku = 'CUSTOM-SKU-99';
    let desc = 'RAW UNCLASSIFIED ERP ITEM';
    let cost = 15.0;
    let brand = 'Independent Distributor';
    let qty = 50;

    lines.forEach(line => {
      const lower = line.toLowerCase();
      if (lower.includes('sku:')) sku = line.split(/sku:/i)[1].trim();
      else if (lower.includes('desc:')) desc = line.split(/desc:/i)[1].trim();
      else if (lower.includes('cost:')) {
        const parsedCost = parseFloat(line.replace(/[^0-9.]/g, ''));
        if (!isNaN(parsedCost)) cost = parsedCost;
      } else if (lower.includes('brand:'))
        brand = line.split(/brand:/i)[1].trim();
      else if (lower.includes('qty:')) {
        const parsedQty = parseInt(line.replace(/[^0-9]/g, ''), 10);
        if (!isNaN(parsedQty)) qty = parsedQty;
      }
    });

    // Clean up description and make title
    let cleanDesc = desc
      .replace(/cs|bx|pk|cs\/|dz/gi, '')
      .replace(/\s+/g, ' ')
      .trim();
    // Capitalize words
    const capitalizedTitle = cleanDesc
      .split(' ')
      .map(w => w.charAt(0).toUpperCase() + w.slice(1).toLowerCase())
      .join(' ');

    // Multipliers for pricing
    const markup = channel === 'faire' ? 1.3 : 1.5;
    const retailPrice = Math.round(cost * markup * 100) / 100;
    const marginPercent = Math.round(
      ((retailPrice - cost) / retailPrice) * 100
    );
    const profitVal = Math.round((retailPrice - cost) * 100) / 100;

    const channelLabel = {
      shopify: 'Shopify Draft Store',
      amazon: 'Amazon FBA Listing',
      walmart: 'Walmart.com Listing',
      faire: 'Faire Wholesale B2B'
    }[channel];

    const toneLabel = {
      seo: 'E-commerce SEO Optimized',
      prof: 'Professional & Informative',
      tech: 'Direct & Technical Specs',
      warm: 'Warm & Story-driven'
    }[selectedTone];

    const title = `${capitalizedTitle} – Premium ${
      channel === 'faire' ? 'Wholesale Case' : 'Retail Pack'
    }`;
    const category =
      'Business & Industrial > Supplier Stock > General Inventory';

    return {
      title,
      category,
      categoryCode: `Auto-Assigned Taxon ID: #9833`,
      retailPrice,
      cost,
      margin: `${marginPercent}%`,
      profit: profitVal,
      description: `Upgrade your business inventory with the ${capitalizedTitle}. Professionally sourced from ${brand}, this highly durable asset represents an optimal solution for commercial partners seeking robust utility and reliable performance. Crafted to industry standards, it delivers excellent utility across professional operations. Packaged specifically for immediate deployment in ${channelLabel} environments and optimized in a ${toneLabel} tone.`,
      features: [
        {
          title: 'Premium Brand Quality',
          desc: `Manufactured and warranted by ${brand} for guaranteed service life and rigorous quality control.`
        },
        {
          title: 'Operational Value',
          desc: `A high-demand commercial asset optimized for competitive reseller margins and steady shelf rotation.`
        },
        {
          title: 'Standard Specification',
          desc: `Manufactured in accordance with rigorous commercial guidelines under SKU: ${sku}.`
        },
        {
          title: 'Ready for Distribution',
          desc: `Pre-packed and structured directly from ERP data to minimize listing friction on digital channels.`
        }
      ],
      attributes: {
        SKU: sku,
        'Manufacturer/Brand': brand,
        'Original ERP Desc': desc,
        'Import Cost Basis': `$${cost.toFixed(2)}`,
        'Inventory Status': `In Stock (${qty} units available)`,
        'Optimization Format': `${channelLabel} - ${toneLabel}`
      },
      tags: [
        'custom-catalog',
        'automated-listing',
        'erp-sync',
        sku.toLowerCase()
      ],
      json: {
        product: {
          title: title,
          body_html: `<p>Upgrade your business inventory with the ${capitalizedTitle}...</p>`,
          vendor: brand,
          product_type: 'Commercial Supply',
          status: 'draft',
          tags: ['custom-catalog', 'automated-listing', 'erp-sync'],
          variants: [
            {
              sku: sku,
              price: retailPrice.toString(),
              cost_per_item: cost.toString(),
              inventory_quantity: qty
            }
          ]
        }
      },
      copy: {
        social: `💼 Bulk operations simplified! Now stocking ${title} wholesale. Premium durability sourced from ${brand}, perfect for immediate deployment. Heavy duty packaging. Contact our sales desk or order directly online today. SKU: ${sku} #WholesaleDistributor #B2BSupply`,
        email: `Subject: Inventory Alert: ${title} Now Available to Order\n\nDear Partner,\n\nWe are pleased to announce the commercial availability of ${title} (SKU: ${sku}). Formulated for premium durability, this in-demand asset offers a robust ${marginPercent}% margin profile. Log into your reseller portal to request secure shipping today.`,
        wholesale: `${capitalizedTitle}. Commercial grade supply under SKU ${sku}. Premium formulation by ${brand}, optimized for immediate wholesale B2B channels.`
      }
    };
  };

  return (
    <div className="wn-landing">
      <NavbarStandard />

      {/* Scoped Styling block to ensure premium design fits without breaking global site */}
      <style>{`
        .demo-hero {
          padding: 140px 0 60px 0;
          background: linear-gradient(180deg, var(--wn-primary-light) 0%, var(--wn-white) 100%);
          text-align: center;
        }
        .demo-badge {
          display: inline-flex;
          align-items: center;
          gap: 6px;
          padding: 6px 14px;
          background: var(--wn-white);
          border: 1px solid var(--wn-border);
          border-radius: var(--wn-radius-pill);
          font-size: 0.85rem;
          font-weight: 600;
          color: var(--wn-primary);
          box-shadow: var(--wn-shadow-sm);
          margin-bottom: 20px;
        }
        .demo-title {
          font-size: 2.8rem;
          font-weight: 800;
          letter-spacing: -1px;
          margin-bottom: 15px;
        }
        .demo-subtitle {
          font-size: 1.15rem;
          color: var(--wn-text-secondary);
          max-width: 700px;
          margin: 0 auto 30px auto;
        }
        .wn-landing .demo-subtitle {
          margin-left: auto;
          margin-right: auto;
        }
        .demo-container {
          max-width: var(--wn-max-width);
          margin: 0 auto;
          padding: 0 20px 100px 20px;
        }
        .demo-grid {
          display: grid;
          grid-template-columns: 1fr;
          gap: 40px;
        }
        @media(min-width: 992px) {
          .demo-grid {
            grid-template-columns: 450px 1fr;
          }
        }
        .demo-card {
          background: var(--wn-white);
          border: 1px solid var(--wn-border);
          border-radius: var(--wn-radius-md);
          box-shadow: var(--wn-shadow-card);
          padding: 30px;
          height: fit-content;
        }
        .demo-card-title {
          font-size: 1.25rem;
          font-weight: 700;
          margin-bottom: 20px;
          display: flex;
          align-items: center;
          gap: 10px;
          border-bottom: 1px solid var(--wn-border);
          padding-bottom: 12px;
        }
        .preset-grid {
          display: grid;
          grid-template-columns: 1fr 1fr;
          gap: 10px;
          margin-bottom: 25px;
        }
        .preset-btn {
          padding: 10px 12px;
          background: var(--wn-bg-soft);
          border: 1px solid var(--wn-border);
          border-radius: var(--wn-radius-sm);
          font-size: 0.8rem;
          font-weight: 600;
          text-align: left;
          cursor: pointer;
          transition: all 0.2s ease;
          color: var(--wn-text-secondary);
        }
        .preset-btn.active {
          background: var(--wn-primary-light);
          border-color: var(--wn-primary);
          color: var(--wn-primary);
        }
        .raw-textarea {
          width: 100%;
          height: 160px;
          font-family: monospace;
          font-size: 0.85rem;
          padding: 12px;
          border: 1px solid var(--wn-border);
          border-radius: var(--wn-radius-sm);
          background: var(--wn-bg-warm);
          resize: none;
          margin-bottom: 20px;
        }
        .raw-textarea:focus {
          outline: none;
          border-color: var(--wn-primary);
          background: var(--wn-white);
        }
        .field-group {
          margin-bottom: 15px;
        }
        .field-label {
          display: block;
          font-size: 0.85rem;
          font-weight: 600;
          margin-bottom: 6px;
          color: var(--wn-text-secondary);
        }
        .select-input {
          width: 100%;
          padding: 12px;
          border: 1px solid var(--wn-border);
          border-radius: var(--wn-radius-sm);
          font-family: var(--wn-font);
          font-size: 0.9rem;
          background: var(--wn-white);
          cursor: pointer;
        }
        .select-input:focus {
          outline: none;
          border-color: var(--wn-primary);
        }
        .enrich-btn {
          width: 100%;
          padding: 14px;
          background: var(--wn-primary);
          color: var(--wn-white);
          border: none;
          border-radius: var(--wn-radius-pill);
          font-weight: 600;
          cursor: pointer;
          display: flex;
          align-items: center;
          justify-content: center;
          gap: 8px;
          font-size: 1rem;
          box-shadow: 0 4px 12px rgba(59, 160, 217, 0.3);
          transition: all 0.2s ease;
          margin-top: 25px;
        }
        .enrich-btn:hover:not(:disabled) {
          background: var(--wn-primary-hover);
          transform: translateY(-2px);
          box-shadow: 0 6px 16px rgba(59, 160, 217, 0.4);
        }
        .enrich-btn:disabled {
          background: var(--wn-border);
          color: var(--wn-text-light);
          cursor: not-allowed;
          box-shadow: none;
        }
        /* Right Panel styling */
        .results-container {
          min-height: 550px;
          display: flex;
          flex-direction: column;
        }
        .tabs-header {
          display: flex;
          gap: 10px;
          margin-bottom: 20px;
          border-bottom: 1px solid var(--wn-border);
          padding-bottom: 10px;
        }
        .tab-btn {
          padding: 8px 16px;
          background: none;
          border: none;
          font-weight: 600;
          font-size: 0.9rem;
          color: var(--wn-text-light);
          cursor: pointer;
          position: relative;
          transition: all 0.2s ease;
        }
        .tab-btn.active {
          color: var(--wn-text);
        }
        .tab-btn.active::after {
          content: '';
          position: absolute;
          bottom: -11px;
          left: 0;
          right: 0;
          height: 3px;
          background: var(--wn-primary);
          border-radius: var(--wn-radius-pill);
        }
        .empty-state {
          flex: 1;
          display: flex;
          flex-direction: column;
          align-items: center;
          justify-content: center;
          text-align: center;
          padding: 40px;
          background: var(--wn-bg-soft);
          border: 1px dashed var(--wn-border);
          border-radius: var(--wn-radius-md);
        }
        .empty-icon {
          font-size: 3rem;
          color: var(--wn-text-light);
          margin-bottom: 15px;
        }
        .stepper-container {
          flex: 1;
          display: flex;
          flex-direction: column;
          justify-content: center;
          padding: 30px;
        }
        .stepper-header {
          display: flex;
          align-items: center;
          justify-content: space-between;
          margin-bottom: 30px;
        }
        .step-row {
          display: flex;
          align-items: center;
          gap: 15px;
          margin-bottom: 15px;
          font-size: 0.95rem;
          color: var(--wn-text-light);
        }
        .step-row.active {
          color: var(--wn-primary);
          font-weight: 600;
        }
        .step-row.completed {
          color: var(--wn-green);
        }
        .step-circle {
          width: 24px;
          height: 24px;
          border-radius: 50%;
          border: 2px solid var(--wn-border);
          display: flex;
          align-items: center;
          justify-content: center;
          font-size: 0.75rem;
          font-weight: 600;
        }
        .step-row.active .step-circle {
          border-color: var(--wn-primary);
          background: var(--wn-primary-light);
        }
        .step-row.completed .step-circle {
          border-color: var(--wn-green);
          background: var(--wn-green-light);
          color: var(--wn-green);
        }
        /* Preview Tab Layout */
        .preview-header {
          display: flex;
          justify-content: space-between;
          align-items: flex-start;
          gap: 20px;
          margin-bottom: 25px;
        }
        .preview-title {
          font-size: 1.5rem;
          font-weight: 700;
          line-height: 1.3;
        }
        .preview-meta {
          display: flex;
          align-items: center;
          gap: 10px;
          flex-wrap: wrap;
          margin-top: 8px;
        }
        .pill-badge {
          font-size: 0.75rem;
          font-weight: 600;
          padding: 4px 10px;
          border-radius: var(--wn-radius-pill);
        }
        .pill-primary {
          background: var(--wn-primary-light);
          color: var(--wn-primary);
        }
        .pill-green {
          background: var(--wn-green-light);
          color: var(--wn-green);
        }
        .pill-pink {
          background: var(--wn-pink-light);
          color: var(--wn-pink);
        }
        .stats-strip {
          display: grid;
          grid-template-columns: 1fr 1fr 1fr;
          gap: 15px;
          padding: 15px;
          background: var(--wn-bg-soft);
          border-radius: var(--wn-radius-sm);
          margin-bottom: 25px;
        }
        .stat-item {
          text-align: center;
        }
        .stat-label {
          font-size: 0.75rem;
          color: var(--wn-text-light);
          font-weight: 600;
          text-transform: uppercase;
        }
        .stat-val {
          font-size: 1.15rem;
          font-weight: 700;
          margin-top: 2px;
        }
        .description-block {
          font-size: 0.92rem;
          color: var(--wn-text-secondary);
          line-height: 1.6;
          margin-bottom: 25px;
        }
        .features-grid {
          display: grid;
          grid-template-columns: 1fr;
          gap: 15px;
          margin-bottom: 25px;
        }
        @media(min-width: 768px) {
          .features-grid {
            grid-template-columns: 1fr 1fr;
          }
        }
        .feature-box {
          padding: 15px;
          border: 1px solid var(--wn-border);
          border-radius: var(--wn-radius-sm);
          background: var(--wn-bg-warm);
        }
        .feature-box h4 {
          font-size: 0.9rem;
          font-weight: 700;
          margin-bottom: 4px;
        }
        .feature-box p {
          font-size: 0.82rem;
          color: var(--wn-text-secondary);
          margin: 0;
        }
        .attr-table {
          width: 100%;
          border-collapse: collapse;
          margin-bottom: 25px;
          font-size: 0.85rem;
        }
        .attr-table tr {
          border-bottom: 1px solid var(--wn-border);
        }
        .attr-table td {
          padding: 8px 12px;
        }
        .attr-table td:first-child {
          font-weight: 600;
          color: var(--wn-text-light);
          width: 40%;
        }
        .tags-container {
          display: flex;
          flex-wrap: wrap;
          gap: 6px;
        }
        .tag-pill {
          background: var(--wn-bg-soft);
          border: 1px solid var(--wn-border);
          padding: 4px 8px;
          font-size: 0.75rem;
          font-family: monospace;
          border-radius: var(--wn-radius-sm);
        }
        .json-code {
          background: #1e1e24;
          color: #a9b2c3;
          padding: 20px;
          border-radius: var(--wn-radius-sm);
          font-family: monospace;
          font-size: 0.85rem;
          overflow-x: auto;
          max-height: 450px;
          border-left: 3px solid var(--wn-primary);
        }
        .copy-box {
          border: 1px solid var(--wn-border);
          border-radius: var(--wn-radius-sm);
          background: var(--wn-bg-warm);
          padding: 15px;
          margin-bottom: 20px;
          position: relative;
        }
        .copy-box-title {
          font-size: 0.8rem;
          font-weight: 700;
          color: var(--wn-primary);
          text-transform: uppercase;
          margin-bottom: 8px;
          display: flex;
          align-items: center;
          gap: 6px;
        }
        .copy-box-content {
          font-size: 0.88rem;
          color: var(--wn-text-secondary);
          white-space: pre-wrap;
        }
        .copy-action {
          position: absolute;
          top: 15px;
          right: 15px;
          background: none;
          border: none;
          cursor: pointer;
          color: var(--wn-text-light);
          transition: color 0.2s ease;
        }
        .copy-action:hover {
          color: var(--wn-primary);
        }
        /* Spinner animation */
        @keyframes spin {
          0% { transform: rotate(0deg); }
          100% { transform: rotate(360deg); }
        }
        .spin-icon {
          animation: spin 1s linear infinite;
        }
      `}</style>

      {/* Hero Section */}
      <section className="demo-hero">
        <div className="demo-badge">
          <FiCpu /> Interactive Demo Sandbox
        </div>
        <h1 className="demo-title">
          Smart <span className="wn-gradient-text">Catalog Enricher</span>
        </h1>
        <p className="demo-subtitle">
          See how our AI-powered integration pipeline instantly converts flat,
          messy, bare-bones ERP system rows into highly structured,
          conversion-optimized storefront listings.
        </p>
      </section>

      {/* Main Sandbox Workspace */}
      <div className="demo-container">
        <div className="demo-grid">
          {/* Left Panel: Input Workspace */}
          <div className="demo-card">
            <h3 className="demo-card-title">
              <FiTerminal style={{ color: 'var(--wn-primary)' }} /> Input
              Workspace
            </h3>

            <div className="field-group">
              <label className="field-label">
                Select Legacy Vertical Preset:
              </label>
              <div className="preset-grid">
                {Object.values(PRESETS).map(p => (
                  <button
                    key={p.id}
                    className={`preset-btn ${
                      selectedPreset === p.id ? 'active' : ''
                    }`}
                    onClick={() => handlePresetSelect(p.id)}
                    disabled={enriching}
                  >
                    {p.name}
                  </button>
                ))}
              </div>
            </div>

            <form onSubmit={handleEnrich}>
              <div className="field-group">
                <label className="field-label">Raw ERP System Row Data:</label>
                <textarea
                  className="raw-textarea"
                  value={rawText}
                  onChange={e => {
                    setRawText(e.target.value);
                    setSelectedPreset(''); // remove preset highlight on custom edit
                  }}
                  disabled={enriching}
                  placeholder="Paste messy product SKU and details..."
                />
              </div>

              <div className="field-group">
                <label className="field-label">Target Sales Channel:</label>
                <select
                  className="select-input"
                  value={targetChannel}
                  onChange={e => setTargetChannel(e.target.value)}
                  disabled={enriching}
                >
                  <option value="shopify">
                    Shopify Storefront (Draft Product)
                  </option>
                  <option value="amazon">Amazon Wholesale FBA Listing</option>
                  <option value="walmart">Walmart.com Seller Catalog</option>
                  <option value="faire">Faire B2B Wholesale Marketplace</option>
                </select>
              </div>

              <div className="field-group">
                <label className="field-label">Copywriting Tone:</label>
                <select
                  className="select-input"
                  value={tone}
                  onChange={e => setTone(e.target.value)}
                  disabled={enriching}
                >
                  <option value="seo">
                    E-Commerce SEO Optimized (Recommend)
                  </option>
                  <option value="prof">Professional & Informative</option>
                  <option value="tech">
                    Direct & Technical Specifications
                  </option>
                  <option value="warm">Warm & Story-driven</option>
                </select>
              </div>

              <button
                type="submit"
                className="enrich-btn"
                disabled={enriching || !rawText.trim()}
              >
                {enriching ? (
                  <>
                    <FiRefreshCw className="spin-icon" /> Simulating
                    Extraction...
                  </>
                ) : (
                  <>
                    Enrich Catalog Row <FiArrowRight />
                  </>
                )}
              </button>
            </form>
          </div>

          {/* Right Panel: AI Enrichment Engine Output */}
          <div
            className="demo-card"
            style={{ display: 'flex', flexDirection: 'column' }}
          >
            <h3 className="demo-card-title">
              <FiLayers
                style={{
                  color: enriching ? 'var(--wn-primary)' : 'var(--wn-green)'
                }}
              />{' '}
              Enrichment Engine Output
            </h3>

            {/* Empty State */}
            {!enriching && !enrichedData && (
              <div className="empty-state">
                <FiDatabase className="empty-icon" />
                <h5>Ready to Run</h5>
                <p
                  style={{
                    fontSize: '0.85rem',
                    color: 'var(--wn-text-secondary)',
                    margin: '10px 0 0 0'
                  }}
                >
                  Choose a legacy vertical preset on the left, or edit the text
                  with your own product specs, then click "Enrich Catalog Row"
                  to activate the simulation.
                </p>
              </div>
            )}

            {/* Stepper Loader */}
            {enriching && (
              <div className="stepper-container">
                <div className="stepper-header">
                  <h5 style={{ margin: 0, fontWeight: 700 }}>
                    AI Enrichment Pipeline Active
                  </h5>
                  <span
                    className="pill-badge pill-primary"
                    style={{ animation: 'pulse 1.5s infinite' }}
                  >
                    PROCESS RUNNING
                  </span>
                </div>

                <div
                  className={`step-row ${enrichStep === 1 ? 'active' : ''} ${
                    enrichStep > 1 ? 'completed' : ''
                  }`}
                >
                  <div className="step-circle">
                    {enrichStep > 1 ? '✓' : '1'}
                  </div>
                  <span>Parsing messy, non-structured ERP fields...</span>
                </div>

                <div
                  className={`step-row ${enrichStep === 2 ? 'active' : ''} ${
                    enrichStep > 2 ? 'completed' : ''
                  }`}
                >
                  <div className="step-circle">
                    {enrichStep > 2 ? '✓' : '2'}
                  </div>
                  <span>
                    Extracting SKU specifications, packaging & unit counts...
                  </span>
                </div>

                <div
                  className={`step-row ${enrichStep === 3 ? 'active' : ''} ${
                    enrichStep > 3 ? 'completed' : ''
                  }`}
                >
                  <div className="step-circle">
                    {enrichStep > 3 ? '✓' : '3'}
                  </div>
                  <span>
                    Synthesizing high-converting copy and selling
                    propositions...
                  </span>
                </div>

                <div
                  className={`step-row ${enrichStep === 4 ? 'active' : ''} ${
                    enrichStep > 4 ? 'completed' : ''
                  }`}
                >
                  <div className="step-circle">
                    {enrichStep > 4 ? '✓' : '4'}
                  </div>
                  <span>
                    Mapping smart category taxonomy to target sales channel...
                  </span>
                </div>

                <div
                  className={`step-row ${enrichStep === 5 ? 'active' : ''} ${
                    enrichStep > 5 ? 'completed' : ''
                  }`}
                >
                  <div className="step-circle">
                    {enrichStep > 5 ? '✓' : '5'}
                  </div>
                  <span>
                    Assembling compliant structured JSON API payload...
                  </span>
                </div>
              </div>
            )}

            {/* Enriched Content View */}
            {!enriching && enrichedData && (
              <div className="results-container">
                <div className="tabs-header">
                  <button
                    className={`tab-btn ${
                      activeTab === 'preview' ? 'active' : ''
                    }`}
                    onClick={() => setActiveTab('preview')}
                  >
                    Channel Preview
                  </button>
                  <button
                    className={`tab-btn ${
                      activeTab === 'copy' ? 'active' : ''
                    }`}
                    onClick={() => setActiveTab('copy')}
                  >
                    Copy Variations
                  </button>
                  <button
                    className={`tab-btn ${
                      activeTab === 'json' ? 'active' : ''
                    }`}
                    onClick={() => setActiveTab('json')}
                  >
                    API Schema (JSON)
                  </button>
                </div>

                {/* Tab 1: Marketplace Channel Preview */}
                {activeTab === 'preview' && (
                  <div>
                    <div className="preview-header">
                      <div>
                        <h4 className="preview-title">{enrichedData.title}</h4>
                        <div className="preview-meta">
                          <span className="pill-badge pill-primary">
                            {targetChannel === 'shopify' && 'Shopify Draft'}
                            {targetChannel === 'amazon' &&
                              'Amazon FBA Wholesale'}
                            {targetChannel === 'walmart' && 'Walmart Catalog'}
                            {targetChannel === 'faire' && 'Faire Wholesale'}
                          </span>
                          <span
                            className="pill-badge pill-pink"
                            style={{ fontSize: '0.72rem' }}
                          >
                            {enrichedData.category}
                          </span>
                        </div>
                      </div>
                    </div>

                    {/* Stats strip */}
                    <div className="stats-strip">
                      <div
                        className="stat-item"
                        style={{ borderRight: '1px solid var(--wn-border)' }}
                      >
                        <div className="stat-label">ERP COST</div>
                        <div
                          className="stat-val"
                          style={{ color: 'var(--wn-text-secondary)' }}
                        >
                          ${enrichedData.cost.toFixed(2)}
                        </div>
                      </div>
                      <div
                        className="stat-item"
                        style={{ borderRight: '1px solid var(--wn-border)' }}
                      >
                        <div className="stat-label">RETAIL PRICE</div>
                        <div
                          className="stat-val"
                          style={{ color: 'var(--wn-primary)' }}
                        >
                          ${enrichedData.retailPrice.toFixed(2)}
                        </div>
                      </div>
                      <div className="stat-item">
                        <div className="stat-label">GROSS MARGIN</div>
                        <div
                          className="stat-val"
                          style={{ color: 'var(--wn-green)' }}
                        >
                          {enrichedData.margin}
                        </div>
                      </div>
                    </div>

                    <div className="description-block">
                      <h5
                        style={{
                          fontWeight: 700,
                          fontSize: '0.95rem',
                          marginBottom: '8px'
                        }}
                      >
                        Product Description:
                      </h5>
                      <p style={{ margin: 0 }}>{enrichedData.description}</p>
                    </div>

                    <div className="description-block">
                      <h5
                        style={{
                          fontWeight: 700,
                          fontSize: '0.95rem',
                          marginBottom: '10px'
                        }}
                      >
                        Key Selling Points:
                      </h5>
                      <div className="features-grid">
                        {enrichedData.features.map((f, idx) => (
                          <div key={idx} className="feature-box">
                            <h4>{f.title}</h4>
                            <p>{f.desc}</p>
                          </div>
                        ))}
                      </div>
                    </div>

                    <div className="description-block">
                      <h5
                        style={{
                          fontWeight: 700,
                          fontSize: '0.95rem',
                          marginBottom: '10px'
                        }}
                      >
                        Auto-Extracted Attributes:
                      </h5>
                      <table className="attr-table">
                        <tbody>
                          {Object.entries(enrichedData.attributes).map(
                            ([key, val]) => (
                              <tr key={key}>
                                <td>{key}</td>
                                <td>{val}</td>
                              </tr>
                            )
                          )}
                        </tbody>
                      </table>
                    </div>

                    <div className="description-block">
                      <h5
                        style={{
                          fontWeight: 700,
                          fontSize: '0.95rem',
                          marginBottom: '10px'
                        }}
                      >
                        Smart Meta Tags:
                      </h5>
                      <div className="tags-container">
                        {enrichedData.tags.map((t, idx) => (
                          <span key={idx} className="tag-pill">
                            #{t}
                          </span>
                        ))}
                      </div>
                    </div>
                  </div>
                )}

                {/* Tab 2: Marketing Copy Variations */}
                {activeTab === 'copy' && (
                  <div>
                    <p
                      style={{
                        fontSize: '0.85rem',
                        color: 'var(--wn-text-light)',
                        marginBottom: '20px'
                      }}
                    >
                      Our integration suite doesn't just write a single
                      description. It compiles a complete marketing launch pad
                      ready for your sales reps, social channels, and customer
                      mailers:
                    </p>

                    <div className="copy-box">
                      <div className="copy-box-title">
                        <FiTrendingUp /> Social Media Outreach Post
                      </div>
                      <div className="copy-box-content">
                        {enrichedData.copy.social}
                      </div>
                      <button
                        className="copy-action"
                        onClick={() =>
                          navigator.clipboard.writeText(
                            enrichedData.copy.social
                          )
                        }
                        title="Copy to Clipboard"
                      >
                        <FiCopy />
                      </button>
                    </div>

                    <div className="copy-box">
                      <div className="copy-box-title">
                        <FiCheckCircle /> Sales Email Teaser (Target Resellers)
                      </div>
                      <div className="copy-box-content">
                        {enrichedData.copy.email}
                      </div>
                      <button
                        className="copy-action"
                        onClick={() =>
                          navigator.clipboard.writeText(enrichedData.copy.email)
                        }
                        title="Copy to Clipboard"
                      >
                        <FiCopy />
                      </button>
                    </div>

                    <div className="copy-box">
                      <div className="copy-box-title">
                        <FiAward /> Wholesale Catalog Snippet (Printed/PDF)
                      </div>
                      <div className="copy-box-content">
                        {enrichedData.copy.wholesale}
                      </div>
                      <button
                        className="copy-action"
                        onClick={() =>
                          navigator.clipboard.writeText(
                            enrichedData.copy.wholesale
                          )
                        }
                        title="Copy to Clipboard"
                      >
                        <FiCopy />
                      </button>
                    </div>
                  </div>
                )}

                {/* Tab 3: API Schema JSON */}
                {activeTab === 'json' && (
                  <div>
                    <p
                      style={{
                        fontSize: '0.85rem',
                        color: 'var(--wn-text-light)',
                        marginBottom: '15px'
                      }}
                    >
                      This compliant structured JSON payload is engineered to
                      match the schemas expected by NetSuite ERP, Matrixify, and
                      modern storefront APIs. It runs behind the scenes to sync
                      physical inventory seamlessly:
                    </p>
                    <pre className="json-code">
                      {JSON.stringify(enrichedData.json, null, 2)}
                    </pre>
                  </div>
                )}
              </div>
            )}
          </div>
        </div>
      </div>

      <FooterStandard />
    </div>
  );
};

export default CatalogEnricherDemo;
